<!--
    秒杀组件 类型1  均匀分布
-->

<template>
  <div class="seckill-1" @click="edit">
    <div id="point_wrapper">
      <div class="s-1-header">
        <span>限时秒杀</span>
        <p>
          <span class="time">05</span>
          <span>时</span>
          <span class="time">06</span>
          <span>分</span>
          <span class="time">60</span>
          <span>秒</span>
        </p>
        <span>更多》</span>
      </div>

      <el-row>
        <el-col :span="12">
          <div class="seckill-item">
            <img :src="defaultImg" alt="" />
            <p class="s-name">商品名称</p>
            <p class="s-price">
              <span>商品价格</span>
              <span>已售量</span>
            </p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="seckill-item">
            <img :src="defaultImg" alt="" />
            <p class="s-name">商品名称</p>
            <p class="s-price">
              <span>商品价格</span>
              <span>已售量</span>
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cptData: {
      type: Object,
      default: {
        componentName: 'seckill_1',
        selectStatus: false,
        data: {}
      }
    }
  },
  data() {
    return {
      defaultImg: require('@/asset/icon/saoma@2x.png')
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style lang="less" scoped>
@import './com.less';
.seckill-1 {
  padding: 10px 5px;
  background-color: @color-background;

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 2px @color-border;
  }

  & > div {
    font-size: 14px;
    .s-1-header {
      padding: 0 10px 10px;
      p {
        display: inline-block;
        margin-left: 10px;
        span {
          display: inline-block;
          width: 18px;
          height: 18px;
        }
        .time {
          background-color: rgba(000, 000, 000, 0.8);
          color: @color-background;
        }
      }
      span:last-of-type {
        float: right;
      }
    }
    .seckill-item {
      text-align: center;
      img {
        width: 90%;
        height: 120px;
      }
      .s-name {
        padding: 5px 0;
      }
      .s-price {
        padding: 5px 10px;

        span {
          &:nth-child(1) {
            float: left;
          }
          &:nth-child(2) {
            float: right;
          }
        }
      }
    }
  }
}
</style>
